import "./styles.scss";
import React, { FC } from "react";
import CompanyExtraDetailItem from "./CompanyExtraDetailItem";
import CompanyAttachmentItem, {
  attachmentTypes,
} from "./CompanyAttachmentItem";
import { reactUtils } from "../../utilities";

interface IProps {
  title?: string;
  company: { long_description: string };
  companyType?: any[],
  tags?: any[],
  attachments?: any[]
}

const CompanyAboutContent: FC<IProps> = (props: IProps) => {
  const { attachments = [], tags = [], company, title, companyType } = props;
  const titleClass: string = title === undefined ? "--hide" : "--show";

  return (
    <div className="ps-company-about-content">
      <h4
        className={`ps-company-about-content__title ps-company-about-content${titleClass}`}
      >
        {title}
      </h4>
      <div className="ps-company-about-content__main-text">
        <div
          className=""
          dangerouslySetInnerHTML={{
            __html: reactUtils.quillDeltaToHtml(company?.long_description ?? ""),
          }}
        />
      </div>

       <div
        className={`ps-company-about-content__extra-details ${
          tags.length == 0 ? "ps-company-about-content--hide" : ""
        }`}
      >
        <CompanyExtraDetailItem title={"Tags"} chips={tags ?? ["Demo"]} />
        {companyType && (
          <CompanyExtraDetailItem title={"Company Type"} chips={companyType} />
        )}
      </div>

       <div
        className={`ps-company-about-content__attachments ${
          attachments.length == 0 ? "ps-company-about-content--hide" : ""
        }`}
      >
        <CompanyAttachmentItem attachmentType={attachmentTypes[0]} />
        <CompanyAttachmentItem attachmentType={attachmentTypes[1]} />
      </div>
    </div>
  );
};

export default CompanyAboutContent;
